import { useRef as a, useState as m, useEffect as l, useMemo as d } from "react";
let n;
function i(e = document.body) {
  const t = getComputedStyle(e), o = t.getPropertyValue("font-weight") || "normal", c = t.getPropertyValue("font-size") || "16px", s = t.getPropertyValue("font-family") || "Open Sans";
  return `${o} ${c} ${s}`;
}
function h(e) {
  n || (n = document.createElement("canvas"));
  const t = n.getContext("2d");
  return t.font = i(), t.measureText(e).width;
}
function x(e) {
  n || (n = document.createElement("canvas"));
  const t = n.getContext("2d");
  return t.font = i(e), t.measureText(e.textContent ?? "").width;
}
function p() {
  const e = a(null), [t, o] = m(!1);
  return l(() => {
    const c = e.current;
    if (c instanceof HTMLElement) {
      const s = new ResizeObserver((r) => {
        if (r[0]) {
          const u = r[0].contentRect, f = x(c);
          o(Math.round(f) > Math.round(u.width));
        }
      });
      return s.observe(c, { box: "content-box" }), function() {
        s.disconnect();
      };
    }
  }, []), d(
    () => ({
      textElmRef: e,
      isOverflowing: t
    }),
    [e, t]
  );
}
export {
  h as estimateTextWidth,
  i as getFont,
  x as getTextWidth,
  p as useIsTextOverflowing
};
